module.exports = __webpack_public_path__ + "static/media/29ADMSPC16.2df05a6b.jpg";